import { HydratedCallRecord } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/call_record.pb';
import { i18next } from '@frontend/i18n';
import { getFullName } from '@frontend/name';
import { formatPhoneNumber, sanitizePhoneNumber } from '@frontend/phone-numbers';

export const isStringNumeric = (callerName: string): boolean => {
  return /^[+-]?\d+(\.\d+)?$/.test(callerName);
};

// Sometimes caller name is a number, in that case, we show 'Unknown' caller name
// Sometimes we don't have person information so we might need to show number instead person name.
export const getFormattedCallerName = (callerName: string): string => {
  return !!callerName && isStringNumeric(callerName)
    ? formatPhoneNumber(callerName)
    : i18next.t('Unknown', { ns: 'calls' });
};

export const getFallbackCallerName = (contactNumber?: string): string => {
  const sanitizedNumber = sanitizePhoneNumber(contactNumber ?? '');
  return !!sanitizedNumber ? getFormattedCallerName(sanitizedNumber) : i18next.t('Unknown', { ns: 'calls' });
};

export const getShortHandName = (callInfo: HydratedCallRecord): string => {
  const { callerNumber, person } = callInfo;
  return person ? getFullName(person) : getFallbackCallerName(callerNumber);
};
